import { gql } from '@apollo/client'

const profileRequestOccasionsFragment = gql`
  fragment profileRequestOccasionsFragment on Market {
    requestOccasions(first: $requestOccasionFirst, productType: $productType) {
      edges {
        node {
          ... on PublicRequestOccasion {
            id
            internalName
            title
            image
            emoji
            icon
            color
          }
        }
      }
    }
  }
`

export default profileRequestOccasionsFragment
